export default __webpack_public_path__ + "static/media/left.19ad08b7.png";